import { Router } from '@angular/router';
import { UntypedFormBuilder, FormControl, FormControlName, UntypedFormGroup, Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { Authenticationservice } from '../../services/authentication.service';
import { Observable } from 'rxjs';
declare var $: any;

@Component({
  selector: 'app-askforfactor67',
  templateUrl: './askforfactor67.component.html',
  styleUrls: ['./askforfactor67.component.css']
})
export class Askforfactor67Component implements OnInit, OnDestroy {

  zone: any;
  usercode: any;
  Formfactor: UntypedFormGroup;
  submitted = false;

  constructor(private spinner: NgxSpinnerService, private auth: Authenticationservice, private fb: UntypedFormBuilder) {
    let userdata: any;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.usercode = userdata.supcode;
    this.goloadfarmerinzone();
    this.goloadstock();

  }

  list_doc = { cemecal: ['', 0, 0, 0, ''], organic: ['', 0, 0, 0, ''], dolomite: ['', 0, 0, 0, ''], medical: ['', 0, 0, 0, ''], machine: ["", 0, 0, 0, ""] };

  ngOnInit(): void {
    this.goloadstock_data();
  }
  year = ['2425', '6768', '67/68', '2567/2568']

  txtSearch = ['', '', '', '', '', '']
  /* select_index_f(){
     document.getElementById("mySelect").selectedIndex = "0";
   }*/

  // โหลดข้อมูล stock ปุ๋ย
  selected = 0;
  fertilizerstock: any[];
  goloadstock() {
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_StockBRD'
    axios.get(url)
      .then(res => {
        this.fertilizerstock = res.data.recordset;
      }).catch(err => { throw (err) })
  }

  // โหลดข้อมูลชาวไร่ในเขต
  txtFindIn: string;
  famerlist = [];
  famerlist2 = [];
  goloadfarmerinzone() {
    this.spinner.show();
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_fmcodeIn_cp" + this.year[1] + "?supzone=" + this.zone;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[fnc_fmcodeIn_cp${this.year[1]}]('${this.zone.substring(0, 2)}')&w=1=1`

    axios.get(url)
      .then(res => {
        this.spinner.hide();
        let data = res.data;
        this.famerlist = data;
        this.famerlist2 = data;
      }).catch(err => { console.log(err); })
  }

  search_dataFM() {//กรองข้อความ
    let keyword = (this.txtFindIn.trim()).toLowerCase();
    if (keyword == '') { this.famerlist = this.famerlist2; }
    else {
      this.famerlist = this.famerlist2.filter((el) => ((el.fmcode_b1.indexOf(keyword) > -1) || (el.fmname.indexOf(keyword) > -1))) || [];
      //if (this.famerlist.length! > 0) this.famerlist = []
    }
  }
  localstock = '';
  lastPL = 0;
  debt_TKS = 0;
  unlock_fn = ''
  ckack() {
    let fmcode = this.fmcode//((<HTMLInputElement>document.getElementById("codefm")).value).slice(1, 11);
    //let fmcode = this.fmcode;
    //let fmcode = this.fmcode//this.Formfactor.value.fmcode
    //let takecash = this.Formfactor.get('cash').value;
    let takecash = this.ckcash;
    var ckfamer = this.famerlist2.filter(el => el.fmcode_b1 == fmcode);
    this.lastPL = ckfamer[0].lastPercentLoan;
    this.debt_TKS = ckfamer[0].debt_TKS;
    this.unlock_fn = ckfamer[0].unlock_fn;

    if (fmcode == null || fmcode == '') null
    else if ((ckfamer[0].PromiseIN == 0 || ckfamer[0].approve == 'N') && !takecash) {
      alert("ไม่สามารถเบิกได้ค่ะ");
      this.ckfarmercan = true;
    }
    else if (ckfamer[0].zoneban == 'Y' && !takecash) {
      alert("ไม่สามารถเบิกได้ค่ะ เนื่องจากเป็นโซนต้องห้าม");
      this.ckfarmercan = true;
    }
    else {
      this.ckfarmercan = false;
    }
    console.log('ckack-', 'takecash', takecash, 'ckfarmercan', this.ckfarmercan);
    console.log('ckack-', ckfamer, fmcode)
  }

  sum_balance = { balance_amt1: 0, balance_amt2: 0, balance_amt3: 0, balance_amt4: 0, sum_balance: 0, sum_toget: 0, tofert: 0 };
  getFert3 = false;
  ckcash = false;
  // โหลดข้อมูลชาวไร่ 1 คน
  dataonefarmer: any;
  ckfarmercan = false;
  goloaddata() {
    let fmcode = this.fmcode//((<HTMLInputElement>document.getElementById("codefm")).value).slice(1, 11);
    this.oneplant = []
    if (fmcode == '') { }
    else {
      this.ckack();
      if (!this.ckfarmercan) {
        this.dataonefarmer = null;
        //  โหลดแปลงชาวไร่
        this.spinner.show();
        let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_cp" + this.year[1] + "_getFert12]&w=fmcode='" + fmcode + "'";
        axios.get(url)
          .then(res => {
            this.spinner.hide();
            let data = res.data;
            this.famername = '';
            if (data.length >= 1) {
              this.dataonefarmer = (data);
              this.dataonefarmer.sort((a, b) => { return b.landvalue - a.landvalue; });
              this.sum_balance.balance_amt1 = data.reduce((total, item) => total + item.balance_amt1, 0);
              this.sum_balance.balance_amt2 = data.reduce((total, item) => total + item.balance_amt2, 0);
              this.sum_balance.balance_amt3 = data.reduce((total, item) => total + item.balance_amt3, 0);
              this.sum_balance.balance_amt4 = data.reduce((total, item) => total + item.balance_amt4, 0);
              this.sum_balance.sum_balance = (this.sum_balance.balance_amt1 + this.sum_balance.balance_amt2 + this.sum_balance.balance_amt3 + this.sum_balance.balance_amt4);
              this.sum_balance.tofert = data.reduce((total, item) => total + item.tofert, 0);
              this.sum_balance.sum_toget = data.reduce((total, item) => total + item.sum_toget, 0);

              console.log('sum_balance:', this.sum_balance);
            }
          }).catch(err => { console.log(err); })
        //this.goloadfertiltzerbyfmcode(fmcode);
        this.Loadaskforfactorlist(fmcode);
        this.ck_money_amt_fm(fmcode);
        /*this.ck_sum_money_amt(fmcode);
        this.lodadck_realty_debt(fmcode);*/
      }

    }
  }
  //  รายการด้านล่าง
  onecode: any[];
  Loadaskforfactorlist(fmcode = '') {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfactor" + this.year[1] + "]&w=[fmcode]='" + fmcode + "'")
      .then(res => {
        this.spinner.show();
        let data = res.data;
        data.sort((a, b) => {
          return new Date(b.datepost).getTime() - new Date(a.datepost).getTime();
        });
        this.onecode = data;
        this.spinner.hide();
      }).catch(err => { console.log(err); })
  }

  sum_money_amt = 0 //วงเงินที่ใช้ไป
  sum_money_amt1 = 0 //ขอเกี้ยว
  sum_money_amt2 = 0 //ขอเปิกปัจจัย

  RSUM_long = 0 //หนี้คงค้างของปี
  credit = 0 //มีวงเงิน
  limit = 0 //คงเหลือ

  ck_money_amt_last: any[];
  ck_realty_debt: any[];

  ck_money_amt_fm(fmcode: string) {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[fnc_ck_money_amt_fm6768]('${fmcode}')&w=1=1`;
    this.spinner.show();
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      console.log('ck_money_amt_fm:', data);
      if (data.length > 0) {
        this.ck_money_amt_last = data;
        this.sum_money_amt1 = data[0].sum_money_amt1;
        this.sum_money_amt2 = data[0].sum_money_amt2;
        this.sum_money_amt = data[0].sum_money_amt;

        this.ck_realty_debt = data;
        this.RSUM_long = data[0].RSUM_long + this.debt_TKS;
        this.credit = (data[0].guaranter + data[0].sumRealty);
        setTimeout(() => {
          if (this.credit > 0 || this.RSUM_long > 0)
            this.limit = (this.credit) - (data[0].sum_money_amt + data[0].RSUM_long)
        }, 100);
      } else {
        this.ck_realty_debt = [];
        this.RSUM_long = 0;
        this.credit = 0;
        this.limit = 0;

        this.sum_money_amt = 0;
        this.sum_money_amt1 = 0;
        this.sum_money_amt2 = 0;
      }

    }).catch(err => { throw (err); })
  }

  clearFm() {
    this.fmcode = '';
    this.oneplant = [];
    this.dataonefarmer = null;
  }

  /*//  โหลดข้อมูลปุ๋ยในแปลง
  ferplantdata: any;
  goloadfertiltzerbyfmcode(fmcode) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_cp6566_basic_aw?fmcode='" + fmcode + "'";
    axios.get(url)
      .then(res => {
        this.ferplantdata = res.data.recordset;
      }).catch(err => { console.log(err); })
  }*/

  stock_data: any[];
  stock_d1: any[]; stock_d2: any[]; stock_d3: any[]; stock_d4: any[]; stock_d5: any[];
  goloadstock_data() {
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=stock_id,description,amt_in,amt_out,CntUnitMsr,group_type,per_unit&f=[dbo].[stock]&w=[amt_in]>0or[amt_out]>0";
    axios.get(url)
      .then(res => {
        let data = res.data;
        this.stock_data = data;
        this.stock_d1 = data.filter((el: any) => el.group_type == '1');
        this.stock_d2 = data.filter((el: any) => el.group_type == '2');
        this.stock_d3 = data.filter((el: any) => el.group_type == '3');
        this.stock_d4 = data.filter((el: any) => el.group_type == '4');
        this.stock_d5 = data.filter((el: any) => el.group_type == '5');
        /*
        console.log('stock_data',this.stock_data);    
        console.log('stock1',this.stock_d1);   console.log('stock2',this.stock_d2);
        console.log('stock3',this.stock_d3);   console.log('stock4',this.stock_d4);
        console.log('stock5',this.stock_d5);
        */
        //this.filtOpt1 = this.myControl.valueChanges.pipe(startWith(''),map(value => this._filter(value)));

      }).catch(err => { console.log(err); })
    this.spinner.hide();
  }

  // เลือก 1 แปลง
  oneplant = [];
  famername: string;
  intlandno: string;
  detailsplant: string
  ck_Fert3 = false;
  Selectoneplant(data) {
    //let data = this.dataonefarmer.filter(el => el.itid == itid);
    console.log('oneplant', data);
    this.famername = data[0].fmname;
    this.intlandno = data[0].intlandno;

    if (data[0].ck_Fert3) this.ck_Fert3 = true;
    else this.ck_Fert3 = false;
    this.getFert3 = false;

    this.detailsplant = data[0].canetype + ' พื้นที่ ' + parseFloat(data[0].landvalue.toFixed(2));
    this.oneplant = data
    this.Change_amt(0);

  }

  sum_amtlast = 0;

  cangetcaneOrganic: any;
  name_doc = [, , , ,]
  ChangeValue(id: number) {
    let doc = this.list_doc;
    console.log('list_doc:', doc);
    this.cangetcaneOrganic = this.oneplant[0].balance_Organic;
    // let lastdata = this.oneplant[0].balance_Organic;
    if (id == 1) {
      this.cemecal = this.sumBalance(doc.cemecal);
    }
    else if (id == 2) {
      this.organic = this.sumBalance(doc.organic);
    }
    else if (id == 3) {
      this.dolomite = this.sumBalance(doc.dolomite);
    }
    else if (id == 4) {
      this.medical = this.sumBalance(doc.medical);
    }
    else if (id == 5) {
      this.machine = this.sumBalance(doc.machine);
    }
    this.sum_amtlast = (this.cemecal.amt_last || 0) + (this.organic.amt_last || 0) + (this.dolomite.amt_last || 0) + (this.medical.amt_last || 0) + (this.machine.amt_last || 0);
  }
  cemecal: any = {};
  organic: any = {};
  dolomite: any = {};
  medical: any = {};
  machine: any = {};
  /*
  { cemecal: [], fertilizer: [], dolomite: [], medical: [], machine: [], }
  */

  sumBalance(data = []): {} {
    //let data - data//[] = this.Formfactor.get('machine').value;
    let sd = { get: '', name: '', amt: 0, amt_val: 0, amt_last: 0 };
    sd.get = (data[0]);
    sd.name = data[4];
    if (this.localstock == '00') sd.amt = data[2]
    else sd.amt = data[3]
    //this.amt_last5=(this.amt_5)*(this.amt_val5)
    if (data[0] == '') sd.amt_val = 0;
    else if (sd.amt_val > 0) { }
    else { sd.amt_val = 1; }
    sd.amt_last = sd.amt_val * sd.amt;
    console.log('dataval_sd', sd.name, data, sd)
    return sd;
  }
  Change_amt(id: number) {
    // let lastdata = this.oneplant[0].balance_Organic;
    if (id == 0) {
      this.cemecal = { get: '', name: '', amt: 0, amt_val: 0, amt_last: 0 };
      this.organic = { get: '', name: '', amt: 0, amt_val: 0, amt_last: 0 };
      this.dolomite = { get: '', name: '', amt: 0, amt_val: 0, amt_last: 0 };
      this.medical = { get: '', name: '', amt: 0, amt_val: 0, amt_last: 0 };
      this.machine = { get: '', name: '', amt: 0, amt_val: 0, amt_last: 0 };
      this.txtSearch = ['', '', '', '', '', '']
      this.list_doc.cemecal = this.list_doc.dolomite = this.list_doc.machine = this.list_doc.medical = this.list_doc.organic = ["", 0, 0, 0, ""]
    }
    else if (id == 1) {
      this.cemecal.amt_last = this.cemecal.amt * this.cemecal.amt_val
    }
    else if (id == 2) {
      this.organic.amt_last = this.organic.amt * this.organic.amt_val
    }
    else if (id == 3) {
      this.dolomite.amt_last = this.dolomite.amt * this.dolomite.amt_val
    }
    else if (id == 4) {
      this.medical.amt_last = this.medical.amt * this.medical.amt_val
    }
    else if (id == 5) {
      this.machine.amt_last = this.machine.amt * this.machine.amt_val
    }

    this.sum_amtlast = (this.cemecal.amt_last || 0) + (this.organic.amt_last || 0) + (this.dolomite.amt_last || 0) + (this.medical.amt_last || 0) + (this.machine.amt_last || 0);
  }
  if_getFert3() {
    if (this.getFert3) {
      this.organic = { get: '', name: '', amt: 0, amt_val: 0, amt_last: 0 };
      this.dolomite = { get: '', name: '', amt: 0, amt_val: 0, amt_last: 0 };
      this.medical = { get: '', name: '', amt: 0, amt_val: 0, amt_last: 0 };
      this.machine = { get: '', name: '', amt: 0, amt_val: 0, amt_last: 0 };
      this.list_doc.dolomite = this.list_doc.machine = this.list_doc.medical = this.list_doc.organic = ["", 0, 0, 0, ""]
    }
    this.Change_amt(1);
  }

  //บันทึกข้อมูลเบิกปัจจัย
  Savedatafactor() {
    this.submitted = true;
    //let dataIs = this.Formfactor.value
    //console.log('dataIs', dataIs)
    let localstock = this.localstock//dataIs.localstock
    let cem = this.cemecal;
    let org = this.organic;
    let dol = this.dolomite;
    let med = this.medical;
    let mac = this.machine;
    //let takecash = this.Formfactor.get('cash').value;
    let takecash = this.ckcash
    let cash = 0;
    let getFert3 = 'N';
    let sumlast = this.sum_amtlast;
    /*
    if (medical == '0000-0000') { medical = 0; }
    */
    if (takecash) cash = 1;
    if (this.getFert3) getFert3 = 'Y';
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/insert_getfactorw?supcode='${this.usercode}'
      &factor_type=2&YearID='${this.year[1]}'
      &doc_status=8&itid='${this.oneplant[0].itid}'
      &intlandno='${this.intlandno}'
      &fmcode='${this.oneplant[0].fmcode}'
      &stockid='${localstock.trim()}'&getFert3='${getFert3}'
      &get1='${cem.get}'&amt1=${cem.amt_val}
      &get2='${org.get}'&amt2=${org.amt_val}
      &get3='${med.get}'&amt3=${med.amt_val}
      &get4='${dol.get}'&amt4=${dol.amt_val}
      &get5='${mac.get}'&amt5=${mac.amt_val}
      &money_amt=${sumlast}&take_method=${cash}`;
    url = url.replace(/\n\s*/g, '\n');

    if (this.oneplant.length == 0) {
      alert("กรุณาเลือกแปลง");
    }
    else if (localstock.length == 0) {
      alert("กรุณาเลือกรายการสต็อค");
    }
    else if (sumlast <= 0) {
      alert("กรุณาใส่จำนวนที่จะเบิกให้มากกว่า 0");
    }
    else if (cash != 1) {
      let unlock = this.unlock_fn;
      //if ((countcemecal) > (this.oneplant[0].balance_fert12 * parseInt(cemecal[1]))) {
      if (cem.amt_val > 0 && (cem.amt_last > this.oneplant[0].balance_amt1) && !this.getFert3 && unlock != 'Y') {
        alert("ไม่สามารถเบิกปุ๋ยเคมีเกิน วงเงินปุ๋ยรายแปลงได้");
      }
      else if ((cem.amt_last > this.sum_balance.sum_balance) && this.getFert3 && unlock != 'Y') {
        alert("ไม่สามารถเบิกปุ๋ยรอบ3 เกินวงเงินปัจจัยคงเหลือได้");
      }
      else if ((cem.amt_last > this.sum_balance.sum_balance && unlock != 'Y')) {
        alert("ไม่สามารถเบิกวงเงินปัจจัยคงเหลือได้");
      }      /*else if ((countdolomite) > (this.oneplant[0].balance_Dolomite * parseInt(dolomite[1]))) {
        alert("ไม่สามารถเบิกโดโลไมท์ได้ เนื่องจากเกินจำนวน");
        console.log((countdolomite));
      
      else if ((countfertilizer) > (this.oneplant[0].balance_Organic * parseInt(fertilizer[1]))) {
        alert("ไม่สามารถเบิกปุ๋ยอินทรีย์ได้ เนื่องจากเกินจำนวน");
        console.log(this.oneplant[0].balance_Organic * parseInt(fertilizer[1]));
        console.log((countfertilizer));
      }}*/
      else if (sumlast > this.limit && unlock != 'Y') {
        alert(`ไม่สามารถเบิกได้ เนื่องจากยอดรวม ${sumlast} เกินหลักทรัพย์ค้ำประกัน ${this.limit.toLocaleString('th-TH')}`);
        console.log('unlock_fn:', unlock, ', sum_amtlast:', sumlast, ', limit:', this.limit);
      }
      /*else if (sumlast > this.limit) {
        if (confirm("เนื่องจากยอดรวม " + sumlast + " เกินวงเงินคงเหลือ " + this.limit + " ต้องการการบันทึกข้อมูล")) {
          //alert("ไม่สามารถเบิกได้ เนื่องจากยอดรวม "+sumlast+" เกินวงเงินคงเหลือ "+this.limit);        
          console.log('sum_amtlast', sumlast, 'limit', this.limit);
          this.SendRequese(url);
        }
      }*/
      else {
        //end_con(url, sumlast);
        //console.log('ยืนยัน-url:', url);
        if (confirm(`ยืนยันการบันทึกการขอเบิก ราคา ${sumlast.toLocaleString('th-TH')} บาท`)) {
          this.SendRequese(url);
        }
      }
    }
    else {
      //end_con(url, sumlast);
      //console.log('ยืนยัน-url:', url);
      if (confirm(`ยืนยันการบันทึกการขอเบิก ราคา ${sumlast.toLocaleString('th-TH')} บาท`)) {
        this.SendRequese(url);
      }
    }
  }

  //ส่งบันทึกข้อมูลเบิกปัจจัย
  SendRequese(url: string) {
    axios.post(url).then(res => {
      if (res.data.rowsAffected == 1) {
        //this.Formfactor.reset();
        alert("บันทึกข้อมูลเรียบร้อยแล้วค่ะ ^^");
        this.Loadaskforfactorlist(this.oneplant[0].fmcode);
        this.ck_money_amt_fm(this.oneplant[0].fmcode);

        this.goloaddata();
        this.oneplant = [];
        this.cleardata();
      }
      else if (res.data.code) {
        alert("บันทึกข้อมูลไม่สำเร็จกรุณาลองใหม่ ^^");
      }
      else {
        alert("บันทึกข้อมูลไม่สำเร็จกรุณาลองใหม่ ^^");
      }
    }).catch(err => { throw (err) })
  }

  //  clear input
  cleardata() {
    this.Change_amt(0);
    //this.Formfactor.reset();
    //this.Formfactor.get("localstock").setValue('');
    /*  this.Formfactor.get("cemecal").setValue(0);
        this.Formfactor.get("fertilizer").setValue(0);
        this.Formfactor.get("dolomite").setValue(0);
        this.Formfactor.get("medical").setValue(0);
        this.Formfactor.get("machine").setValue(0);*/

    this.oneplant = [];
    this.famername = null;
    this.intlandno = null;
    this.localstock = '';
    this.sum_amtlast = 0;
    //this.val_st()
    //$("input[type=number]").val('0');
  }

  fmcode = ''
  cancledata(data: any) {
    let fmcode = this.fmcode //((<HTMLInputElement>document.getElementById("codefm")).value).slice(1, 11);
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?[firebaseid]=" + data.firebaseid + "&doc_status='X'";
    //console.log('cancledata url:', url);
    if (confirm('ต้องยกเลิกรายการนี้ ' + data.docid + ' ใช่หรือไม่') == true) {
      axios.post(url)
        .then(res => {
          if (res.data.rowsAffected == 1) {
            alert("ยกเลิกเรียบร้อยแล้วค่ะ ^^");
            this.Loadaskforfactorlist(fmcode);
          }
          else if (res.data.code) {
            alert("ยกเลิกไม่สำเร็จกรุณาลองใหม่ ^^");
          }
          else {
            alert("ยกเลิกไม่สำเร็จกรุณาลองใหม่ ^^");
          }
        }).catch(err => { throw (err) })
      this.goloaddata();
    }
    else { }
  }


  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    /*  this.organicdata = null;
      this.chemicaldata = null;
      this.dolomitedata = null;
      this.machinedata = null;
      this.medicdata = null;*/
    this.stock_data = null;
    this.fertilizerstock = null;
    this.famerlist = null;
    this.dataonefarmer = null;
  }

}
